<style>
    #help-menu {
        width: 4em;
        height: 4em;
    }
</style>

<template>
    <v-menu offset-y class="help">
        <v-btn slot="activator" dark flat class="v-btn--icon" id="help-menu">
            <v-icon>help</v-icon>
        </v-btn>
        <v-list>
            <v-list-tile @click="openDocument()">
                <v-list-tile-content>Help</v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>

import { getHelpFile }  from '../utils/effort-tracking-api' 

export default {
    name: 'help-controls',
    methods: {
        openDocument() {
            var document = getHelpFile(this.$store.state.usertype);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/HelpControls.vue